import React from 'react';

export class HrBlock extends React.Component {
	render() {
		return <hr />
	}
};



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/hrPlugin/components/HrBlock.jsx